var render, staticRenderFns
import script from "./BuidingReportInfo.vue?vue&type=script&lang=js&"
export * from "./BuidingReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuidingReportInfo.vue?vue&type=style&index=0&id=79d14261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d14261",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d14261')) {
      api.createRecord('79d14261', component.options)
    } else {
      api.reload('79d14261', component.options)
    }
    
  }
}
component.options.__file = "src/views/report/view-report/components/BuidingReportInfo.vue"
export default component.exports